module.exports = __webpack_public_path__ + "img/aeroland-client-logo-01.e0193824.png";